import journeysQueries from "../gql/queries";
import { fetchFromGraphql } from "entities/helpers/gqlCall";

export const fetchJourneyGroups = async () => {
  const query = journeysQueries.fetchJourneyGroups;
  const queryVars = { journeyGroupType: "DXO", includeInactive: false };
  const { journeyGroups } = await fetchFromGraphql(query, queryVars, "journeyGroups");

  return journeyGroups;
};

// returns an array of Journey objects with the tasks_due_counts fields for the given date.
/**
 *
 * @param {Number} selectedJourneyGroupId
 * @param {Number} taskOwnerUserId
 * @param {Array of Strings} taskStatuses // eg ["IN_PROGRESS"]
 * @param {Date} selectedDate
 * @returns
 [
  { 
    id: 1, 
    name: "Introduction", 
    tasks_due_counts: {
      total: 0,
      completed: 0,
      Email: 0,
      Call: 0,
      Other: 0,
      LinedIn: 0,
      Print Mail: 0,
      ThankView: 0,
      Text: 0,
    } 
  },
  { 
    id: 2, 
    name: "Solicitation", 
    tasks_due_counts: {
      total: 0,
      completed: 0,
      Email: 0,
      Call: 0,
      Other: 0,
      LinedIn: 0,
      Print Mail: 0,
      ThankView: 0,
      Text: 0,
    } 
  },
 ]
 */
export const fetchJourneyTitlesAndCounts = async (journeyGroupId, taskOwnerUserId, taskStatuses, selectedDate) => {
  if (!journeyGroupId) return [];

  const query = journeysQueries.fetchJourneyTitles;
  const queryVars = {
    journeyGroupId,
    taskOwnerUserId,
    taskStatuses,
    selectedDate,
  };

  const { journeysForJourneyGroup } = await fetchFromGraphql(query, queryVars, "journeysForJourneyGroup");
  return journeysForJourneyGroup;
};

export const fetchAllJourneysForAllJourneyGroups = async () => {
  const groups = await fetchJourneyGroups();
  return (await Promise.all(groups.map(async (group) => await fetchJourneysForProfile(group.id)))).flat();
};

const fetchJourneysForProfile = async (journeyGroupId) => {
  const query = journeysQueries.fetchJourneysForProfile;
  const queryVars = { journeyGroupId };
  const { journeysForJourneyGroup } = await fetchFromGraphql(query, queryVars, "journeysForJourneyGroup");

  return journeysForJourneyGroup;
};
